import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { DefaultButton } from 'office-ui-fabric-react/lib';
import { firebaseConnect, isLoaded } from 'react-redux-firebase';
import { PropTypes } from 'prop-types';
import { CSVLink } from 'react-csv';
import { profileStateToParams } from '../../utils/enhacers';
import { formatShortDate } from '../../utils/dates';
import { playerCsvKeys } from '../../utils/playerFields';
import { profilePropType } from '../../utils/proptypes';
import { modelUser } from '../PlayersList/Forms/Jugadores';

function TeamsList({ teams, jugadores, profile }) {
  // Defense in depth behind the button's role gate; `|| {}` keeps a null profile from throwing.
  const { isAdmin, isSuperAdmin } = profile || {};
  const csvKeys = playerCsvKeys({
    modelKeys: Object.keys(modelUser),
    esAdminOsuperAdmin: !!(isAdmin || isSuperAdmin),
  });

  if (!isLoaded(jugadores) || !isLoaded(teams) || !teams || !jugadores) {
    return null;
  }

  const csv = [['team', 'shortName', ...csvKeys]];

  Object.keys(jugadores).forEach((teamId) => {
    Object.values(jugadores[teamId]).forEach((value) => {
      const values = csvKeys.map((key) => {
        if (key === 'fullName') {
          return `${value.name || ''} ${value.lastName || ''}`.trim();
        }
        return key === 'birthday' ? formatShortDate(value[key]) : value[key];
      });
      const team = teams[teamId] || {};
      const shortName = (team.shortName || '').toUpperCase();
      csv.push([team.name || '', shortName, ...values]);
    });
  });

  return (
    <CSVLink data={csv} filename="all-soccer-cup.csv">
      <DefaultButton>
        Descargar todos los equipos ({Object.keys(teams).length})
      </DefaultButton>
    </CSVLink>
  );
}

TeamsList.propTypes = {
  teams: PropTypes.shape({}),
  jugadores: PropTypes.shape({}),
  profile: profilePropType,
};

TeamsList.defaultProps = {
  teams: undefined,
  jugadores: undefined,
  profile: {},
};

export default compose(
  // `teams` is intentionally NOT watched here: TeamsList already subscribes to
  // `/teams` (ordered), and react-redux-firebase tears listeners down with
  // `ref(path).off(type)`, which detaches EVERY listener at that location. A
  // second subscription with its own query id would be counted separately, so
  // when this component unmounts (team selected) it would kill TeamsList's live
  // watcher and silently freeze `data.teams`. One subscription per RTDB
  // location; `teams` arrives through `connect(profileStateToParams)`.
  firebaseConnect(() => [{ path: 'jugadores' }]),
  connect(profileStateToParams),
)(TeamsList);
